var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('kst-skeleton',{attrs:{"active":_vm.isLoading}}),(_vm.defaultSlotVisible)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }